import { AffordabilityOffReason, OutcomeResponse } from '@shared/models';

interface IgniteResponseError {
  statusCode: string | null;
  message: string | null;
}

interface MinimumRentalNeededAmount {
  period: number;
  amount: number;
  asantoCalculation: string;
}

interface MaximumLoanAmount {
  period: number;
  amount: number;
}

export class IgniteResponse {
  public affordabilitySearchId: string | null = null;
  public source: string | null = null;
  public lenderName: string = '';
  public lenderLogoUrl?: string;
  public affordabilityOffReason: AffordabilityOffReason | null = null;
  public maximumLoanAmount: number | null = null;
  public maximumLoanAmounts?: MaximumLoanAmount[] | null;
  public minimumRentalNeededAmounts?: MinimumRentalNeededAmount[] | null;
  public maximumAffordableLoanAmount: number | null = null;
  public maximumAffordableLoanAmountDescription?: string | null;
  public maximumValue: number | null = null;
  public affordabilityResult: string | null = null;
  public quoteNumber: string | null = null;
  public error: IgniteResponseError | null = null;
  public httpError: string | null = null;
  public httpErrorMessage: string | null = null;
  public tooManyApplicants: boolean | null = null;
  public limitToTwoIncomes?: boolean | null = null;
  public payrate: number | null = null;
  public stressRate: number | null = null;
  public icr: number | null = null;

  // UI only
  public expanded?: boolean;

  public static response(outcome: OutcomeResponse): IgniteResponse {
    return {
      affordabilitySearchId: null,
      source: null,
      lenderName: outcome.overallResult.lender,
      lenderLogoUrl: outcome.overallResult.lenderLogoUrl,
      affordabilityOffReason: outcome.overallResult.affordabilityOffReason,
      maximumLoanAmount: null,
      maximumLoanAmounts: null,
      minimumRentalNeededAmounts: null,
      maximumAffordableLoanAmount: null,
      maximumValue: null,
      affordabilityResult: null,
      quoteNumber: null,
      error: null,
      httpError: null,
      httpErrorMessage: null,
      tooManyApplicants: null,
      limitToTwoIncomes: null,
      payrate: null,
      stressRate: null,
      expanded: false,
      icr: null,
    };
  }
}
